import type { ReactElement } from "react";
import { Link } from "react-router";

import { useSearchForm } from "../../forms/use-search-form.js";

import { tenantUserUrls } from "./urls.js";

/** 状態の選択肢 1 つ（サーバの ApiTenantUserStatusChoice）。 */
export interface StatusChoice {
    readonly value: number;
    readonly label: string;
}

/**
 * 一覧の検索欄。<b>GET のフォームと同じ動き</b>（結果の URL をそのまま共有・再読み込みできる）。
 *
 * 欄の名前は API が受ける形（<c>Search.Keyword</c> / <c>Search.Status</c>）。
 */
export function UserSearchForm({ tenantId, keyword, status, choices, filtered }: {
    readonly tenantId: number;
    readonly keyword: string | null;
    readonly status: number | null;
    readonly choices: readonly StatusChoice[];
    readonly filtered: boolean;
}): ReactElement {
    // 空の欄も載せる（API が受ける形）。条件が変わったら欄の値を書き戻す（解除・戻る）——作り直すとフォーカスが外れる
    const form = useSearchForm(tenantUserUrls.index(tenantId), {
        "Search.Keyword": keyword ?? "", "Search.Status": status === null ? "" : String(status),
    }, true);

    return (
        <form method="get" className="mb-4 grid gap-3 sm:grid-cols-[1fr_auto_auto]" {...form.props}>
            <div>
                <label className="sr-only" htmlFor="Search_Keyword">名前・メールアドレスで探す</label>
                <input
                    className="form-input" id="Search_Keyword" name="Search.Keyword" type="search"
                    placeholder="名前・メールアドレス" autoComplete="off" defaultValue={keyword ?? ""}
                />
            </div>
            <div>
                <label className="sr-only" htmlFor="Search_Status">状態</label>
                <select
                    className="form-select" id="Search_Status" name="Search.Status"
                    defaultValue={status === null ? "" : String(status)}
                >
                    <option value="">すべての状態</option>
                    {choices.map((choice) => (
                        <option key={choice.value} value={String(choice.value)}>{choice.label}</option>
                    ))}
                </select>
            </div>
            <div className="flex gap-2">
                <button type="submit" className="btn-primary">検索</button>
                {filtered ? <Link className="btn-secondary" to={tenantUserUrls.index(tenantId)}>解除</Link> : null}
            </div>
        </form>
    );
}
